import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { LanguageService } from '../services/language.service';
import {Language, Languages} from '../../core/languages';

@Component({
  selector: 'app-language-picker',
  templateUrl: './language-picker.component.html',
  styleUrls: ['./language-picker.component.scss']
})
export class LanguagePickerComponent implements OnInit {

  languages = Languages.values();
  currentLanguage: Language;

  constructor(
    private route: ActivatedRoute,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit() {
    this.languageService.currentLanguage.subscribe(currentLanguage => this.currentLanguage = currentLanguage);
  }

  changeLanguage(language: Language) {
    this.languageService.useLanguage(language);
  }
}
